// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-icon {
  position: absolute;
  bottom: 16px;
  right: 35px;
  font-size: 18px;
  cursor: pointer;
}
.popup-assist-shortcut-container {
  width: 100%;
}
.popup-assist-shortcut {
  margin-right: 20px;
  line-height: 1.25;
  opacity: 0.8;
  cursor: pointer;
  margin-top: 10px;
}
.popup-assist-shortcut:hover {
  color: #f16464;
  opacity: 1;
}
.trans-add-content-box::placeholder {
  opacity: 0.8;
}
.popup-message-user {
  background-color: rgba(75, 75, 75, 0.05);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  float: right;
  border-bottom-right-radius: 0px;
}
.popup-message-assistant {
  padding: 10px;
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 10px;
  float: left;
  width: 100%;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Apply the animation to the icon-loading class */
.popup-assistant-loading {
  display: inline-block;
  animation: spin 1s linear infinite;
}
.popup-assistant-send-button {
  border: 2px solid #f16464;
  color: #f16464;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  text-align: center;
  width: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupAssist/popupAssist.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".send-icon {\n  position: absolute;\n  bottom: 16px;\n  right: 35px;\n  font-size: 18px;\n  cursor: pointer;\n}\n.popup-assist-shortcut-container {\n  width: 100%;\n}\n.popup-assist-shortcut {\n  margin-right: 20px;\n  line-height: 1.25;\n  opacity: 0.8;\n  cursor: pointer;\n  margin-top: 10px;\n}\n.popup-assist-shortcut:hover {\n  color: #f16464;\n  opacity: 1;\n}\n.trans-add-content-box::placeholder {\n  opacity: 0.8;\n}\n.popup-message-user {\n  background-color: rgba(75, 75, 75, 0.05);\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  float: right;\n  border-bottom-right-radius: 0px;\n}\n.popup-message-assistant {\n  padding: 10px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-bottom: 10px;\n  float: left;\n  width: 100%;\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Apply the animation to the icon-loading class */\n.popup-assistant-loading {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n.popup-assistant-send-button {\n  border: 2px solid #f16464;\n  color: #f16464;\n  border-radius: 8px;\n  padding: 10px;\n  margin-top: 10px;\n  cursor: pointer;\n  text-align: center;\n  width: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
